<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xiii"></a>MUSLIM FAMILIES IN GLOBAL SENEGAL</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?dcfa6e20